import React__default from 'react';
import { useDropdownState } from './use_dropdown_state.js';
import '../button/index.js';
import { Button } from '../button/button.js';

/**
 * Button that toggles the visibility of DropdownMenu.
 */
const DropdownButton = ({ onClick, ...rest }) => {
    const { id, open, refs, getReferenceProps, kind, size, disabled, className } = useDropdownState();
    const handleClick = React__default.useCallback(async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await onClick?.(event);
    }, [onClick]);
    return (React__default.createElement(Button, { kind: kind, disabled: disabled, size: size, className: className, ...rest, ref: refs.setReference, ...getReferenceProps({ onClick: handleClick }), id: `${id}-button`, "aria-haspopup": "menu", "aria-controls": open ? `${id}-menu` : undefined, "aria-expanded": open ? true : undefined }));
};

export { DropdownButton };
